module.exports = __webpack_public_path__ + "img/strava.5f264f44.svg";